<div
    class="tracking-status"
    [class.tracking-status--active]="active"
    [class.tracking-status--first]="first"
    [class.tracking-status--last]="last"
>
    <svg
        *ngIf="active"
        width="79"
        height="78"
        viewBox="0 0 79 78"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="tracking-status__circle"
        [class.tracking-status__circle--success]="type === 'success'"
        [class.tracking-status__circle--warning]="type === 'warning'"
        [class.tracking-status__circle--danger]="type === 'danger'"
    >
        <g clip-path="url(#clip0)">
            <circle cx="39.0049" cy="39" r="31" fill="#CCC" fill-opacity="0.5" class="circle-outline" />
            <circle cx="39.0049" cy="39" r="37.5" stroke="#CCC" stroke-opacity="0.2" stroke-width="3" class="circle-outter" />
            <circle cx="38.9795" cy="38.7104" r="23.0264" fill="#CCC" class="circle-inner" />
            <path
                *ngIf="type === 'success' || type === 'warning'"
                d="M52.0396 29.9739C51.4075 29.3418 50.3823 29.3418 49.7501 29.974L35.453 44.2711L27.9269 36.7451C27.2948 36.1129 26.2696 36.1129 25.6373 36.7451C25.005 37.3772 25.005 38.4024 25.6373 39.0347L34.3081 47.7055C34.6243 48.0217 35.0386 48.1797 35.4529 48.1797C35.8672 48.1797 36.2816 48.0216 36.5977 47.7055L52.0396 32.2636C52.6719 31.6314 52.6719 30.6062 52.0396 29.9739Z"
                fill="white"
            />

            <path
                *ngIf="type === 'danger'"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M43.6119 45.3385L37.4102 39.1367L31.2084 45.3385C30.5234 46.0235 29.4127 46.0235 28.7277 45.3385C28.0427 44.6534 28.0427 43.5428 28.7277 42.8578L34.9295 36.656L28.7277 30.4542C28.0427 29.7692 28.0427 28.6586 28.7277 27.9735C29.4127 27.2885 30.5234 27.2885 31.2084 27.9735L37.4102 34.1753L43.6119 27.9735C44.2969 27.2885 45.4076 27.2885 46.0926 27.9735C46.7776 28.6586 46.7776 29.7692 46.0926 30.4542L39.8909 36.656L46.0926 42.8578C46.7776 43.5428 46.7776 44.6534 46.0926 45.3385C45.4076 46.0235 44.2969 46.0235 43.6119 45.3385Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="78" height="78" fill="white" transform="matrix(1 0 0 -1 0.00488281 78)" />
            </clipPath>
        </defs>
    </svg>
    <div *ngIf="!active" class="tracking-status__circle">
        <span>
            {{ index }}
        </span>
    </div>
    <span class="tracking-status__title">{{ title }}</span>
</div>
